import React ,{useState,useEffect } from 'react'
import PricingTable from '../common/PricingTable'
import Header from '../common/Header'


function Pricing() {
    const [currency, setCurrency] = useState(15000);
    const [noOfAdd, setNoOfAdd] = useState(15000);
    const [price, setPrice] = useState(1);
    
    useEffect(() => {
        setPrice(((1/currency)*noOfAdd).toFixed(5))
    }, [currency,noOfAdd])
    
        
    
    
  return (
    <>
        <Header/>
        <section className="section2" id="" data-section="section1">
			<div className="container">
				<div className="caption">
					<div className="btm-form" style={{padding:"50px 15px 50px"}}>
						<div className="pb-5">
							<div className="col-md-11 m-auto">
								<h1 className="mb-5 text-center offer-head"><b>We Offer The Best Prices of Any Token Multisender</b></h1>
								<div data-v-90fa70b0="" className="mt-4 pt-2 article-content">
									<p>Not only are we the cheapest, but our pricing model is very different compared to any multisender in the crypto market. How so? The service fees we charge are dynamic, unlike other multisender tools.</p>
									<p style={{color:"#ffe565",fontWeight:"500"}}>Attention! These prices do not include the cost of gas fees.</p>
									<h3 className="pt-3">Here's what we mean by dynamic fees</h3>
									<p>With Crypto MultiTokendrop, the service fee is based on the size of a batch transfer (i.e. the number of addresses to send tokens to). The fees are as follows:</p>
									<PricingTable/>
									<p>
										Our dynamic pricing model is one of the things that sets us aside from the competition. Other multisenders charge a set fee, no matter how many recipients a batch transfer has. For example, one of the most popular multisender tools charges 0.09 ETH on the Ethereum network, 0.5 BNB on the BSC network, and 100 MATIC on the Polygon (MATIC) chain, even when sending tokens to just 5 users! To find out more about this, read this case study we made titled Why are airdrop fees so high?
									</p>
									<p>On the other end of the spectrum is our approach, you pay for what you use. No more and no less. We aim to cater for all types of users. For instance, users who regularly send tokens to just 20 - 30 addresses, we can accommodate their needs without extorting them.</p>
									{/* <h3 className="pt-5 fill-head">Fill in the form below to become an affiliate partner</h3> */}
									<div id="">
										<form className="vue-form">
											<fieldset>
												<div>
												    <label htnlFor="name" className="label">Enter the number of recipients and select network</label>
												    <div className="row m-0">
												        <div className="col-md-6 m-0 p-0">
												            <input type="number" name="name" id="name" placeholder="e.g. 10000" required="required" value={noOfAdd} onChange={(events)=>{setNoOfAdd(events.target.value)}}/>
												        </div>
												        <div className="col-md-6 m-0 p-0">
                                                        <select className='sele-Eth' name="format" id="format" value={currency}  onChange={(events)=>{setCurrency(Number(events.target.value))}}>
                                                            <option value={15000}>ETH</option>
                                                            <option value={3500}>BNB</option>
                                                            <option value={10}>MATIC</option>
                                                            <option value={600}>AVAX</option>
                                                            <option value={250}>TRX</option> 
                                                        </select>
												        </div>
												    </div>
												</div>
												{currency === 15000 ?<span className="counter py-2" style={{fontSize:"14px"}}>Rate: 1 ETH / 15,000 wallet addresses</span>:
												currency === 3500 ? <span className="counter py-2" style={{fontSize:"14px"}}>Rate: 1 BNB / 3500 wallet addresses</span>:
												currency === 10  ? <span className="counter py-2" style={{fontSize:"14px"}}>Rate: 1 MATIC / 10 wallet addresses</span>:
												currency === 600  ? <span className="counter py-2" style={{fontSize:"14px"}}>Rate: 1 AVAX / 600 wallet addresses</span>:
												currency === 250  ? <span className="counter py-2" style={{fontSize:"14px"}}>Rate: 1 TRX / 250 wallet addresses</span>:null}
												<span style={{display:"block",fontSize:"24px",margin:"10px 0 30px",fontWeight:"500"}}>Fee: {price} {currency === 15000 ? 'ETH' : currency === 3500 ? 'BNB': currency === 10 ? 'MATIC' : currency === 600 ? 'AVAX' : currency === 250 ? 'TRX':null}  + network charges</span>
											</fieldset>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
    </>
  )
}

export default Pricing